<template>
  <div class="stock-momentum-view">
    <StockMomentum />
  </div>
</template>

<script>
import StockMomentum from '@/components/indicators/StockMomentum.vue'

export default {
  name: 'StockMomentumView',
  components: {
    StockMomentum
  }
}
</script>

<style scoped>
.stock-momentum-view {
  padding: 20px;
  flex: 1;
}
</style>
